/* eslint-disable */
import Searchbar from '../components/Filter/components/search';
import Select from '../components/Filter/components/select';
import MultiSelect from '../components/Filter/components/multiSelect';
import DatePicker from 'components/DatePicker';
import Button from '../components/Button';
import { useForm, Controller } from 'react-hook-form';
import { filter, find } from 'lodash';
import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';
import translating from '../translate.json';
import '../components/Filter/style.scss';
import { useEffect, useState } from 'react';
import AutocompleteComp from 'components/Filter/components/autocomplete';
const useCustomForm = ({
  fields,
  data,
  handleFilter,
  handleReset,
  ssf,
  defaultValues = {}
}) => {
  const { reset, register, watch, control, getValues } = useForm({
    defaultValues: defaultValues
  });

  const watchAllFields = watch();

  const [filtersFields, setFiltersFields] = useState(watchAllFields);
  const searchFun = (item, filters) => {
    for (var index in filters) {
      if (filters[index] !== '') {
        let currentField = find(fields, { name: index });
        switch (currentField?.type) {
          case 'search': {
            let searchFound = false;
            currentField.fields?.forEach((searchField, i, currentField) => {
              searchFound = item?.[searchField]
                ?.toString()
                ?.toLowerCase()
                ?.includes(filters[index]?.toLowerCase());
              if (searchFound) currentField.length = i + 1;
            });
            if (!searchFound) return false;
            break;
          }
          case 'select':
            if (
              filters[index] !== 'all' &&
              filters[index] !== translating.all &&
              !(item?.[currentField.name] === filters[index])
            )
              return false;
            break;
          case 'multiselect':
            if (
              filters[index] !== 'all' &&
              !isEmpty(filters[index]) &&
              filters[index] !== translating.all &&
              !filters[index].includes(item?.[currentField?.name]) &&
              !filters[index].includes(
                item?.[currentField?.name]?.[currentField?.subField]
              )
            )
              return false;
            break;
          case 'date':
            if (filters[index] !== null) {
              if (currentField.subType === 'toDate') {
                if (
                  new Date(item?.[currentField?.field]) >=
                  new Date(filters[index])
                )
                  return false;
              } else if (currentField.subType === 'fromDate')
                if (
                  new Date(item?.[currentField?.field]) <=
                  new Date(filters[index])
                )
                  return false;
            }
            break;
          default:
            break;
        }
      }
    }
    return true;
  };

  const onSubmit = async (filters) => {
    if (ssf && (filters.fromDate !== '' || filters.toDate !== '')) {
      data = await ssf(filters);
      data = data.data;
    } else
      data = data?.filter((t) => {
        return searchFun(t, filters);
      });
    setFiltersFields(watchAllFields);
    handleFilter(data);
  };

  useEffect(() => {
    if (
      !ssf &&
      !isEmpty(watchAllFields) &&
      !isEqual(watchAllFields, filtersFields)
    ) {
      onSubmit(watchAllFields);
    }
  }, [watchAllFields]);

  const renderForm = () => {
    return (
      <div>
        {fields?.length ? (
          <form className="filters">
            <div className="wrapper-filters-inputs">
              {fields?.map((field) =>
                (() => {
                  switch (field?.type) {
                    case 'search':
                      return (
                        <Searchbar
                          field={field}
                          register={register}
                        ></Searchbar>
                      );
                    case 'autocomplete':
                      return (
                        <AutocompleteComp
                          Controller={Controller}
                          control={control}
                          field={field}
                        ></AutocompleteComp>
                      );
                    case 'select':
                      return (
                        <Select
                          Controller={Controller}
                          control={control}
                          field={field}
                        ></Select>
                      );
                    case 'multiselect':
                      return (
                        <MultiSelect
                          Controller={Controller}
                          control={control}
                          field={field}
                        ></MultiSelect>
                      );
                    case 'date':
                      return (
                        <DatePicker
                          Controller={Controller}
                          control={control}
                          field={field}
                          showLabel={true}
                        ></DatePicker>
                      );
                    default:
                      return <div></div>;
                  }
                })()
              )}
            </div>
            <div className="wrapper-btns">
              <Button
                txt={translating.resetFilters}
                handleClick={() => {
                  reset();
                  setFiltersFields({});
                  handleReset();
                }}
                variant="text"
              ></Button>
              {ssf && (
                <Button
                  txt={translating.filter}
                  handleClick={() => {
                    onSubmit(watchAllFields);
                  }}
                  variant="text"
                ></Button>
              )}
            </div>
          </form>
        ) : (
          <div>no fields to filter</div>
        )}
      </div>
    );
  };

  return {
    reset,
    register,
    watch,
    control,
    renderForm
  };
};

export default useCustomForm;
